export enum NavAction {
  SignIn = 'signIn',
  SignUp = 'signUp',
}
